export const theme = {
    colors: {
        primary: '#B05FFD',
        primaryDark: '#7000c7',
        primaryBright: '#c840e9',
        background: '#010606',
        backgroundSecondary: '#0d0d0d',
        backgroundPurple: '#1a0533',
        backgroundPurpleLight: '#4a1c6b',
        gradientPurple: 'linear-gradient(135deg, #0a0014 0%, #1a0533 25%, #4a1c6b 50%, #8b2fc9 75%, #c840e9 100%)',
        gradientPurpleCard: 'linear-gradient(135deg, #1a0533 0%, #4a1c6b 50%, #8b2fc9 100%)',
        text: '#fff',
        textMuted: 'rgba(255, 255, 255, 0.7)',
        textDark: '#010606',
        white: '#fff',
        black: '#000',
        border: 'rgba(176, 95, 253, 0.3)',
    },
};
